import React from "react";

import { ContentCard, Toggle } from "@narmi/design_system";
import ReactMarkdown from "react-markdown";

// `components.a` instead of `linkTarget`, which react-markdown >= 9 removed
const externalLinkComponents = {
  a: ({ children, href, title }: { children?: React.ReactNode; href?: string; title?: string }) => (
    <a href={href} title={title} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ),
};

const PreferenceContentCard = ({
  title,
  subtitle,
  subtext,
  onChange,
  content = null,
  showToggle = true,
  deactivateToggle = false,
  headerButton = null,
  showSubtext = true,
  renderSubTitleAsMarkdown = false,
  renderSubTextAsMarkdown = false,
}: {
  title: string;
  subtitle?: React.ReactNode;
  subtext?: React.ReactNode;
  onChange?: (isActive: boolean) => void;
  /** Accepted for ContextForm.Field compatibility (injected via cloneElement); unused */
  value?: boolean;
  content?: React.ReactElement | null;
  showToggle?: boolean;
  deactivateToggle?: boolean;
  headerButton?: React.ReactNode;
  showSubtext?: boolean;
  renderSubTitleAsMarkdown?: boolean;
  renderSubTextAsMarkdown?: boolean;
}) => {
  /*
  If using this component outside of azul or AO, make sure copy over the css styles
  TODO: update these styles to cerulean
  */
  return (
    <ContentCard kind="elevated">
      <div className="title-container">
        <h4 className="nds-sans fontSize--heading5">{title}</h4>
        {showToggle && deactivateToggle && (
          <div className="toggle-container">
            <Toggle
              onChange={onChange}
              defaultActive
              isActive
              enabledLabel="enabled"
              disabledLabel="disabled"
            />
          </div>
        )}
        {showToggle && !deactivateToggle && (
          <div className="toggle-container">
            <Toggle onChange={onChange} enabledLabel="enabled" disabledLabel="disabled" />
          </div>
        )}
        {headerButton}
      </div>
      {renderSubTitleAsMarkdown && typeof subtitle === "string" ? (
        <ReactMarkdown components={externalLinkComponents}>{subtitle}</ReactMarkdown>
      ) : (
        <div>{subtitle}</div>
      )}
      {content}
      {showSubtext && (
        <>
          <div className="preference-card-divider" />
          {renderSubTextAsMarkdown && typeof subtext === "string" ? (
            <ReactMarkdown className="subtext" components={externalLinkComponents}>
              {subtext}
            </ReactMarkdown>
          ) : (
            <div className="subtext">{subtext}</div>
          )}
        </>
      )}
    </ContentCard>
  );
};

export default PreferenceContentCard;
